import { Action,
  config,
  defaultProcessingSaga,
  defaultResponseProcessing,
  fetchAuthSaga,
  FetchResponse,
  AnyObject } from '@triare/auth-redux';
import { put, delay, takeLatest, call } from 'redux-saga/effects';
import { actions, Tag } from './index';

export type TagCreateData = AnyObject

export type TagCreateResponse = TagCreateData

export interface TagCreateBody {
  name: string;
  description: string;
  fileId: string;
  tags: Tag['id'][];
}

export const tagCreate = (payload: TagCreateBody): Action<TagCreateBody> => ({
  type: actions.tagCreateTrigger.toString(),
  payload,
});

export const tagCreateClear = (): Action => ({
  type: actions.tagCreateClear.toString(),
});

export function* tagCreateRequestSaga({ payload }: Action<TagCreateBody>) {
  yield put({
    type: actions.tagCreateStart.toString(),
  });

  if (!payload) {
    yield put({
      type: actions.tagCreateError.toString(),
      payload: {
        message: 'TagCreate: Parameters not passed.',
      },
    });

    return;
  }

  const response = (yield call(
    fetchAuthSaga,
    `${process.env.REACT_APP_API}admin/articles/tags`,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
    },
    {},
    config.fetchDelay,
  )) as FetchResponse;

  yield defaultResponseProcessing<TagCreateData, TagCreateResponse>(
    response,
    actions.tagCreateSuccess.toString(),
    actions.tagCreateError.toString(),
    false,
    (tagCreateData) => tagCreateData,
  );
}

export default function* saga() {
  yield takeLatest(
    actions.tagCreateTrigger.toString(),
    defaultProcessingSaga(
      tagCreateRequestSaga,
      {
        error: actions.tagCreateError.toString(),
        locationCancel: actions.tagCreateClear.toString(),
      },
    ),
  );

  yield takeLatest(actions.tagCreateSuccess.toString(), function* clear() {
    if (config.delaySuccess) {
      yield delay(config.delaySuccess);
    }

    // yield put({
    //   type: actions.tagCreateClear.toString(),
    // });
  });

  yield takeLatest(actions.tagCreateError.toString(), function* errorReset() {
    if (config.delayError) {
      yield delay(config.delayError);
    }

    yield put({
      type: actions.tagCreateErrorReset.toString(),
    });
  });
}
